var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"promo-tag-counter",attrs:{"aria-label":"Open promos, offers + more"}},[_c('mr-icon',{attrs:{"name":"tag","height":_vm.iconSize}}),(_vm.couponCount > 0)?_c('div',{staticClass:"count-bubble",class:_vm.size},[_vm._v(_vm._s(_vm.couponCount))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }